import { useBreakpointValue } from '@skin-seoul/design-system';
import type { SelectOption } from './MobileSelect';
import MobileSelect from './MobileSelect';
import DesktopSelect from './DesktopSelect';

interface SelectProps {
  options: SelectOption[];
  value: string;
  onChange: (value: string) => void;
  title?: string;
  width?: string | number;
  showSelectedValue?: boolean;
  /** Form-field treatment: the field name stays visible above the chosen value once one is picked. */
  floatingLabel?: boolean;
}

export const Select = (props: SelectProps) => {
  const isMobile = useBreakpointValue({ base: true, tablet: false });

  return isMobile ? <MobileSelect {...props} /> : <DesktopSelect {...props} />;
};

export default Select;
export type { SelectOption };
